import { Mail } from 'lucide-react';

import { AuthLayout } from '../../components/auth/AuthLayout';
import { SUPPORT_EMAIL, buildSupportMailto } from '../../utils/support';

export const ActivationPendingPage = () => {
  return (
    <AuthLayout
      title="Account Created"
      subtitle="Please check your email to activate your account."
      cardClassName="md:max-h-[90dvh]"
    >
      <div className="flex flex-col items-center gap-5 my-2">
        <div className="flex items-center justify-center w-[60px] h-[60px] rounded-full bg-green01/10">
          <Mail size={40} className="text-green01" />
        </div>

        <p className="text-greyP2 text-sm text-center">
          We've sent an activation link to your email address. Please check your inbox and click the link to activate
          your account.
        </p>

        <p className="text-greyP2 text-sm text-center">
          If you don't see the email, please check your spam folder or contact support at{' '}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            onClick={(e) => {
              e.currentTarget.href = buildSupportMailto();
            }}
            className="text-green01 hover:underline"
          >
            {SUPPORT_EMAIL}
          </a>
          .
        </p>
      </div>
    </AuthLayout>
  );
};
